import React, { useEffect } from 'react';
import { useAppSelector } from 'hooks';

import { Modal } from '~components';
import { DataRow, TableView, useTableViewState } from '~components/table-view';

import { Budget } from '~support-at-home/models';

import columnsFactory from '~support-at-home/forms/budgets/clientBudgetsList';

import { selectClientWithBudgetsById } from '~support-at-home/selectors/clientsWithBudgets';

interface ComponentProps {
  id: number | null | undefined;
  isOpen?: boolean;
  setIsOpen: (val: boolean) => void;
}

const ClientsWithBudgetsModal: React.FC<ComponentProps> = ({ id, isOpen, setIsOpen }) => {
  const client = useAppSelector((state) => selectClientWithBudgetsById(state, id ?? undefined));

  const { data, setData } = useTableViewState<DataRow<Budget>>(
    (client?.budgets ?? []).map((budget) => budget as DataRow<Budget>),
  );

  const columns = columnsFactory();

  useEffect(() => {
    setData((client?.budgets ?? []).map((budget) => budget as DataRow<Budget>));
  }, [client, setData]);

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} size="xl" header={`${client?.full_name}`} headerClassName="header">
      <TableView id="client-with-budgets-modal-table" columns={columns} data={data} />
    </Modal>
  );
};
export default ClientsWithBudgetsModal;
